import { RelationshipStatusSubmissionSpouse } from '../models/submissions/relationship-status-submission-spouse';
import { RelationshipStatusSubmission } from '../models/submissions/relationship-status-submission';

export class RelationshipStatusSubmissionDetailsUtils {
  static relationshipStatusChanged(submission: RelationshipStatusSubmission): boolean {
    return (
      submission?.previous?.relationshipStatusId !== submission.new.relationshipStatusId ||
      submission?.previous?.effectiveDate !== submission.new.effectiveDate
    );
  }

  static spousePersonalInfoChanged(
    prevSpouse: RelationshipStatusSubmissionSpouse | null,
    newSpouse: RelationshipStatusSubmissionSpouse | null
  ): boolean {
    return (
      prevSpouse?.firstName !== newSpouse?.firstName ||
      prevSpouse?.middleName !== newSpouse?.middleName ||
      prevSpouse?.lastName !== newSpouse?.lastName ||
      prevSpouse?.birthDate !== newSpouse?.birthDate ||
      prevSpouse?.socialInsuranceNumber !== newSpouse?.socialInsuranceNumber
    );
  }

  static spouseContactInfoChanged(
    prevSpouse: RelationshipStatusSubmissionSpouse | null,
    newSpouse: RelationshipStatusSubmissionSpouse | null
  ): boolean {
    return (
      prevSpouse?.email !== newSpouse?.email ||
      prevSpouse?.phoneNumber !== newSpouse?.phoneNumber ||
      prevSpouse?.address.addressLine1 !== newSpouse?.address.addressLine1 ||
      prevSpouse?.address.addressLine2 !== newSpouse?.address.addressLine2 ||
      prevSpouse?.address.addressLine3 !== newSpouse?.address.addressLine3 ||
      prevSpouse?.address.city !== newSpouse?.address.city ||
      prevSpouse?.address.stateId !== newSpouse?.address.stateId ||
      prevSpouse?.address.countryId !== newSpouse?.address.countryId ||
      prevSpouse?.address.postalCode !== newSpouse?.address.postalCode
    );
  }
}
